<template>
  <div v-if="visible" class="sp-index-filters-field" :data-testid="TestId.admin.indexFilterInput">
    <IndexFiltersSelect v-if="select" :filter="filter" @change="emit('change')" />
    <IndexFiltersLabels v-else-if="labels" :filter="filter" @change="emit('change')" />
    <IndexFiltersDateRange v-else-if="dates" :filter="filter" @change="emit('change')" />
    <sp-text-field
      v-else-if="text"
      :label="filter.label"
      :value.prop="value"
      :data-testid="TestId.admin.indexFilterText"
      @change="handleChange"
    ></sp-text-field>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useIndexFiltersStore } from "#ce/apps/SpAdmin/SpIndexFilters/store/index-filters";
import IndexFiltersSelect from "./IndexFiltersSelect.ce.vue";
import IndexFiltersLabels from "./IndexFiltersLabels.ce.vue";
import IndexFiltersDateRange from "./IndexFiltersDateRange.ce.vue";

const props = defineProps({ filter: { type: Object, required: true } });
const emit = defineEmits(["change"]);
const store = useIndexFiltersStore();
const visible = computed(() => props.filter.type !== "hidden");
const select = computed(() => props.filter.type === "select");
const labels = computed(() => props.filter.type === "labels");
const dates = computed(() => props.filter.type === "date_range");
const text = computed(() => props.filter.type === "text");
const value = computed(() => store.values[props.filter.param] ?? "");

function handleChange(event) {
  store.setValue(props.filter.param, event.target.value);
  emit("change");
}
</script>
